export const validateAndProcessCsv = (csvData) => {
  const requiredColumns = [
    'headline', 'address', 'phone', 'link', 'image_url', 'lat', 'lon',
    'days', 'main_offer', 'offer_details', 'place_id', 'is_active',
    'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'
  ];

  // Validate headers
  const headers = Object.keys(csvData[0]);
  const missingColumns = requiredColumns.filter(col => !headers.includes(col));
  if (missingColumns.length > 0) {
    throw new Error(`Missing required columns: ${missingColumns.join(', ')}`);
  }

  return csvData.map(row => {
    // Convert string boolean to actual boolean
    const isActive = String(row.is_active).toLowerCase();
    const active = isActive === 'true' || isActive === '1' || isActive === 'yes';

    // Convert time strings to opening hours object
    const opening_hours = {};
    ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']
      .forEach(day => {
        if (row[day]) {
          const timeSlots = row[day].split(',').map(slot => {
            const [start, end] = slot.trim().split('-');
            return { start, end };
          });
          opening_hours[day] = timeSlots;
        } else {
          opening_hours[day] = [];
        }
      });

    // Return formatted venue object
    return {
      headline: row.headline,
      address: row.address,
      phone: row.phone || '',
      link: row.link || '',
      image_url: row.image_url || '',
      lat: parseFloat(row.lat),
      lon: parseFloat(row.lon),
      days: row.days,
      main_offer: row.main_offer,
      offer_details: row.offer_details || '',
      place_id: row.place_id || '',
      is_active: active, // Use the properly parsed boolean
      category: 'hh',
      opening_hours,
      created_at: new Date()
    };
  });
};